import { useState, useEffect } from 'react';

import useCustomTopicName from 'hb-react/shared/apps/TopicsIndexV2/hooks/useCustomTopicName';

export const useTopicActionButton = ({
  name,
  approval_id: approvalId,
  joined_at: joinedAt,
  restricted_access: restrictedAccess,
  automatic_validation: automaticValidation,
}) => {
  const topicsMenuName = useCustomTopicName();
  const hasRequestPending = !!approvalId;
  const [isMember, setIsMember] = useState(!!joinedAt);

  // Initially: open group, not a member = simple join
  let buttonLabel = topicsMenuName
    ? s__('Topics|Join %{topicName}').i__({
        topicName: topicsMenuName,
      })
    : __('Join group');
  let buttonA11yLabel = s__('Topics|Join %{topicName}').i__({
    topicName: name,
  });

  // Already member of the group
  if (isMember) {
    buttonLabel = __('Joined');
    buttonA11yLabel = buttonLabel;
  }

  // Group is private and can't join automatically
  if (!isMember && restrictedAccess && !automaticValidation) {
    if (hasRequestPending) {
      buttonLabel = __('Review request');
      buttonA11yLabel = s__('Topics|Review request to join %{topicName}').i__({
        topicName: name,
      });
    } else {
      buttonLabel = __('Request to join');
      buttonA11yLabel = s__('Topics|Request to join %{topicName}').i__({
        topicName: name,
      });
    }
  }

  useEffect(() => {
    setIsMember(!!joinedAt);
  }, [joinedAt]);

  return {
    buttonLabel,
    buttonA11yLabel,
    isMember,
    setIsMember,
  };
};
